import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IbDisruptedSeatsService } from '../services/ib-disrupted-seats.service';
import { DisruptedSegment, IbDisruptedSeatsSegmentModel } from '../../../../core/models/disrupted-seats/ib-disrupted-seats-segment';
import { IbCModalService } from 'ib-web-commons/ib-modal';

@Component({
    selector: 'ib-disrupted-seat-option-two',
    templateUrl: './ib-disrupted-seat-option-two.component.html',
    styleUrls: []
})
export class IbDisruptedSeatOptionTwoComponent {

    @Input() flowId: string;
    @Output() openSeatmap = new EventEmitter<string>();

    constructor (
        private ibDisruptedSeatsService: IbDisruptedSeatsService,
        private commonsModalService: IbCModalService
    ) {}

    navigateToSeatmap (): void {

        // this.openSeatmap.emit('IB043320250220');

        this.ibDisruptedSeatsService.getDisruptedSeatsSegments(this.flowId).subscribe({
            next: (response: IbDisruptedSeatsSegmentModel) => {
                this.openSeatmap.emit(
                    response.disruptedSegments.find(
                        (disruptedSegment: DisruptedSegment) =>disruptedSegment.available
                    )?.segmentId);

            },
            error: () => {
                this.showGenericError();
            }
        });
    }

    private showGenericError (): void {
        const modalErrorObject = {
            title: 'MODAL_ERROR_TITLE_1',
            body: 'MODAL_ERROR_DESCRIPTION',
            showCancelButton: true
        };
        this.commonsModalService.showGenericError(null, modalErrorObject);
    }

}
